import { render, staticRenderFns } from "./PdvMarketplaceObject.vue?vue&type=template&id=7725bfd8"
import script from "./PdvMarketplaceObject.vue?vue&type=script&lang=js"
export * from "./PdvMarketplaceObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports